import { Roles } from "../../mp-utils/generic-utils"
import { ROLES_BY_ROUTE } from "../constants/nav"
import { NavItem } from "../types"

// Routes that Super Administrator should not have access to
export const SUPER_ADMIN_EXCLUDED_ROUTES = [
  "/reporting/teaching-tools/study-plan",
  "/reporting/configuration"
]

// Helper function to check if a route should be excluded for Super Admin
export const isSuperAdminExcluded = (href: string): boolean => {
  return SUPER_ADMIN_EXCLUDED_ROUTES.some(excludedRoute =>
    href.startsWith(excludedRoute)
  )
}

export const getRoleNavItems = (items: NavItem[], role: string): NavItem[] => {
  if (!items || !role) {
    return []
  }

  return items.reduce<NavItem[]>((acc, item, index) => {
    const newItem = {
      ...item,
      children: item.children ? getRoleNavItems(item.children, role) : undefined
    }

    if (role !== Roles.Super_Administrator) {
      return (index === 0 && !item.href) ||
        ROLES_BY_ROUTE[item.href]?.includes(role)
        ? [...acc, newItem]
        : acc
    }

    // For Super Administrator, check if the route is excluded
    if (item.href && isSuperAdminExcluded(item.href)) {
      return acc
    }

    return [...acc, newItem]
  }, [])
}
